'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _productLabelDownload = require('./product-label-download.component');

var _productLabelDownload2 = _interopRequireDefault(_productLabelDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.components.productLabelDownload', []).component('productLabelDownload', _productLabelDownload2.default).name;


// WEBPACK FOOTER //
// ./components/app/product/information/product-label-download/product-label-download.module.js